import { useGameState } from '../hooks/useGameState';
import { GameHeader } from '../components/GameHeader';
import { GameControls } from '../components/GameControls';
import { memo } from 'react';
import { gameSize } from '../utils/gameSize';

export const GameView = memo(() => {
  const [canvasRef] = useGameState();

  return (
    <div className="w-full h-full">
      <GameHeader />
      <GameControls />
      <canvas
        ref={canvasRef}
        className="w-full h-full pointer-events-none"
        width={gameSize(window.innerWidth)}
        height={gameSize(window.innerHeight)}
      />
    </div>
  );
});
